<template>
  <header>
    <div class="mx-auto max-w-[1500px]">
      <div class="flex flex-wrap md:p-2 xl:px-0 xl:py-6 mb-4">
        <div class="basis-1/3 md:flex items-center space-x-4 hidden">
          <NuxtLink target="_blank" :to="twitter" aria-label="twitter">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="27" height="27" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class="fill-white hover:bg-slate-600 bg-black p-2 rounded-full">
                  <g>
                     <g xmlns="http://www.w3.org/2000/svg">
                        <g>
                           <path d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016    c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992    c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056    c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152    c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792    c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44    C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568    C480.224,136.96,497.728,118.496,512,97.248z" data-original="#000000" class=""/>
                        </g>
                     </g>
                  </g>
               </svg>
          </NuxtLink>
          <NuxtLink target="_blank" :to="facebook" aria-label="facebook">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="27" height="27" x="0" y="0" viewBox="0 0 155.139 155.139" style="enable-background:new 0 0 512 512" xml:space="preserve" class="fill-white hover:bg-slate-600 bg-black p-2 rounded-full">
                  <g>
                     <g xmlns="http://www.w3.org/2000/svg">
                        <path id="f_1_" style="" d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184   c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452   v20.341H37.29v27.585h23.814v70.761H89.584z"  data-original="#010002" />
                     </g>
                  </g>
               </svg>
          </NuxtLink>
          <NuxtLink target="_blank" :to="instagram" aria-label="instagram">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="27" height="27" x="0" y="0" viewBox="0 0 511 511.9" style="enable-background:new 0 0 512 512" xml:space="preserve" class="fill-white hover:bg-slate-600 bg-black p-2 rounded-full">
                  <g>
                     <path xmlns="http://www.w3.org/2000/svg" d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0" data-original="#000000" class=""/>
                    <path xmlns="http://www.w3.org/2000/svg" d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0"  data-original="#000000" class="bg-grayLight"/>
                    <path xmlns="http://www.w3.org/2000/svg" d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0"  />
                  </g>
               </svg>
          </NuxtLink>
          <NuxtLink target="_blank" :to="youtube" aria-label="youtube">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="27" height="27" x="0" y="0" viewBox="0 0 409.592 409.592" style="enable-background:new 0 0 512 512" xml:space="preserve" class="fill-white hover:bg-slate-600 bg-black p-2 rounded-full">
                  <g>
                     <g xmlns="http://www.w3.org/2000/svg">
                        <g>
                           <path d="M403.882,107.206c-2.15-17.935-19.052-35.133-36.736-37.437c-107.837-13.399-216.883-13.399-324.685,0    C24.762,72.068,7.86,89.271,5.71,107.206c-7.613,65.731-7.613,129.464,0,195.18c2.15,17.935,19.052,35.149,36.751,37.437    c107.802,13.399,216.852,13.399,324.685,0c17.684-2.284,34.586-19.502,36.736-37.437    C411.496,236.676,411.496,172.937,403.882,107.206z M170.661,273.074V136.539l102.4,68.27L170.661,273.074z" data-original="#000000" class=""/>
                        </g>
                     </g>
                  </g>
               </svg>
          </NuxtLink>
        </div>
        <div class="flex-1 hidden md:flex flex-row justify-end flex-wrap items-center">
          <div class="flex justify-center items-center">
            <div>
              <NuxtLink
                  href="https://stylishequestrian.com/"
                  target="_blank"
                  aria-label="stylish"
              >
                <nuxt-img
                    preload
                    width="32"
                    height="32"
                    alt="stylishequestrian"
                    class="w-[32px] mr-1" src="/icon3.svg"/>
              </NuxtLink>
            </div>
            <div>
              <NuxtLink
                  :href="brother_link"
                  target="_blank">
                <nuxt-img
                    preload
                    width="52"
                    height="20"
                    alt="logo_small"
                    class="w-[52px] mr-4" :src="logo_small"/>
              </NuxtLink>
            </div>
          </div>
          <div class="flex flex-col md:w-[70%] lg:w-auto">
            <div class="">
                <div class="relative text-black focus-within:text-black max-h-10">
                           <span class="absolute inset-y-0 right-0 flex items-center px-2">
                              <button id="search" @click="submitSearch()" name="search" type="submit" class="p-1 focus:outline-none focus:shadow-outline" aria-label="search">
                                 <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" class="w-6 h-6">
                                    <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                                 </svg>
                              </button>
                           </span>
                  <input type="search" name="q" v-model="search" @keyup.enter="submitSearch()" class="placeholder-custom max-h-8 py-2 text-lg text-black border
                   focus:ring-violet-300 border-neutral-200 pl-4 pr-12 focus:ring-1 focus:shadow-inner focus:outline-none focus:text-black w-full lg:w-[400px]"
                         placeholder="Search" autocomplete="off"
                  >
                </div>
            </div>
          </div>
        </div>
        <div class="w-full mt-1">
          <div class="flex justify-end w-full">
            <nav>
              <ul>
                <li class="font-normal text-base flex">
                  <template  v-if="userName">
                    <NuxtLink :to="(userRoles.includes('Superadmin') || userRoles.includes('Admin')|| userRoles.includes('Moderator'))? '/admin/crm':'/users/account'" class="border-r border-black px-3 hover:underline">{{userName}}</NuxtLink>
                    <div @click="logout()" class="border-r hover:cursor-pointer border-black px-3 hover:underline ">Log out</div>
                  </template>
                  <NuxtLink v-else to="/login" class="border-r border-black px-3 hover:underline">Login</NuxtLink>
                  <NuxtLink to="/contact" class="border-r border-black text-base px-3 hover:underline">Contact Us</NuxtLink>
                  <NuxtLink to="/checkout" class="px-3 flex flex justify-center items-center">
                    <nuxt-img
                        preload
                        format="webp"
                        class="mx-1 h-[14px]" src="/shopping-cart-svgrepo-com.svg" alt="cart" width="14" height="14"/>
                    <span class="text-themeRed">{{countCart}}</span></NuxtLink>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div class="w-full fixed left-0 top-0 z-50 p-2 sm:p-6 md:justify-between md:justify-center md:flex-row bg-white md:flex md:relative min-h-[55px]  sm:min-h-[77px]">
            <div @click="showmenumobile = !showmenumobile; bodyscroll()" class="w-[27px] fixed z-40 md:hidden mt-2">
              <svg :class="{activemobile:showmenumobile}"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30" height="30" x="0" y="0" viewBox="0 0 384 384" style="enable-background:new 0 0 512 512" xml:space="preserve" class="icon-menu cursor-pointer"><g><path xmlns="http://www.w3.org/2000/svg" d="m368 154.667969h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" fill="#000000" data-original="#000000" class="path1"/><path xmlns="http://www.w3.org/2000/svg" d="m368 32h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" fill="#000000" data-original="#000000" class="path2"/><path xmlns="http://www.w3.org/2000/svg" d="m368 277.332031h-352c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h352c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0" fill="#000000" data-original="#000000" class="path3"/></g></svg>
            </div>
          <div></div>
          <div :class="{activemobile:showmenumobile}" class="md:hidden min-h-[100vh] overflow-y-auto h-full w-full mt-[53px] pb-[100px] fixed md:flex left-0 top-0 right-0 bg-white z-30 p-6  mobile-menu">
<!--            <NuxtLink to="/" class="flex w-full justify-center">
              <img class="w-[150px]" src="/logo_c.svg">
            </NuxtLink>-->
            <nav class="mobile-menu-nav">
              <ul>
                <li v-for="(menuItem, menuIndex) in menuItems" :key="menuItem.title"  class="uppercase border-b border-grayLight2 py-1 flex flex-col min-h-[52px] items-center">
                  <template v-if="menuItem.children.length === 0" >
                    <NuxtLink
                        @click.stop="highlightedMenuItem = menuIndex;closeMobileMenu()"
                        :to="menuItem.link"
                        class="hover:underline flex items-center justify-between relative py-2 text-3xl h-[40px] w-full"
                    >
                    {{ menuItem.title }}
                    </NuxtLink>
                  </template>
                  <template v-else>
                    <div
                        @click.stop="(highlightedMenuItem === menuIndex) ? highlightedMenuItem = -1 : highlightedMenuItem = menuIndex"
                        class="hover:underline flex items-center justify-between relative py-2 text-3xl h-[40px] w-full"
                    >
                        <span class="mr-1">
                          {{ menuItem.title }}
                        </span>
                      <svg class="w-5 h-5 text-indigo-100 dark:text-white"
                           xmlns="http://www.w3.org/2000/svg"
                           viewBox="0 0 20 20"
                           fill="#000">
                        <path
                            fill-rule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clip-rule="evenodd"
                        />
                      </svg>
                    </div>
                    <ul
                        :class="highlightedMenuItem === menuIndex ? 'show' : 'hide'"
                        class="font-medium text-3xl pb-2 w-full"
                    >
                      <li v-for="childrenMenuItem in menuItem.children" :key="childrenMenuItem.title">
                        <NuxtLink
                            @click.stop="closeMobileMenu()"
                            :to="childrenMenuItem.link"
                            class="hover:underline p-1 px-3 block"
                        >
                          {{ childrenMenuItem.title }}
                        </NuxtLink>
                      </li>
                    </ul>
                  </template>
                </li>
              </ul>
            </nav>
            <nav class="border-t border-grayDark">
              <ul>
                <li class="font-medium text-2xl uppercase border-b border-grayLight2 py-1 flex flex-col min-h-[52px] items-center">
                  <template  v-if="userName">
                    <NuxtLink :to="(userRoles.includes('Superadmin') || userRoles.includes('Admin')|| userRoles.includes('Moderator'))? '/admin/crm':'/users/account'" class="hover:underline flex items-center relative py-2 text-3xl h-[40px] w-full">{{userName}}</NuxtLink>
                    <div @click="logout()" class="hover:underline flex items-center relative py-2 text-3xl h-[40px] w-full">Log out</div>
                  </template>
                  <NuxtLink v-else
                            @click.stop="closeMobileMenu()"
                            to="/login" class="hover:underline flex items-center relative py-2 text-3xl h-[40px] w-full">Login</NuxtLink>
                </li>
                <li class="font-medium text-2xl uppercase border-b border-grayLight2 py-1 flex flex-col min-h-[52px] items-center">
                  <NuxtLink  @click.stop="closeMobileMenu()" to="/contact" class="hover:underline flex items-center relative py-2 text-3xl h-[40px] w-full">Contact Us</NuxtLink>
                </li>
                <li class="font-medium text-2xl uppercase border-b border-grayLight2 py-1 flex flex-col min-h-[52px] items-center">
                  <NuxtLink  @click.stop="closeMobileMenu()" to="/checkout" class="hover:underline flex items-center relative py-2 text-3xl h-[40px] w-full">Check Out <span class="text-themeRed ml-1">({{countCart}})</span></NuxtLink>
                </li>
              </ul>
            </nav>
            <div class="flex space-x-3 mt-4">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="32" height="32" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class="fill-white hover:bg-black bg-grayLight p-2 rounded-full">
                  <g>
                     <g xmlns="http://www.w3.org/2000/svg">
                        <g>
                           <path d="M512,97.248c-19.04,8.352-39.328,13.888-60.48,16.576c21.76-12.992,38.368-33.408,46.176-58.016    c-20.288,12.096-42.688,20.64-66.56,25.408C411.872,60.704,384.416,48,354.464,48c-58.112,0-104.896,47.168-104.896,104.992    c0,8.32,0.704,16.32,2.432,23.936c-87.264-4.256-164.48-46.08-216.352-109.792c-9.056,15.712-14.368,33.696-14.368,53.056    c0,36.352,18.72,68.576,46.624,87.232c-16.864-0.32-33.408-5.216-47.424-12.928c0,0.32,0,0.736,0,1.152    c0,51.008,36.384,93.376,84.096,103.136c-8.544,2.336-17.856,3.456-27.52,3.456c-6.72,0-13.504-0.384-19.872-1.792    c13.6,41.568,52.192,72.128,98.08,73.12c-35.712,27.936-81.056,44.768-130.144,44.768c-8.608,0-16.864-0.384-25.12-1.44    C46.496,446.88,101.6,464,161.024,464c193.152,0,298.752-160,298.752-298.688c0-4.64-0.16-9.12-0.384-13.568    C480.224,136.96,497.728,118.496,512,97.248z" data-original="#000000" class=""/>
                        </g>
                     </g>
                  </g>
               </svg>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="32" height="32" x="0" y="0" viewBox="0 0 155.139 155.139" style="enable-background:new 0 0 512 512" xml:space="preserve" class="fill-white hover:bg-black bg-grayLight p-2 rounded-full">
                  <g>
                     <g xmlns="http://www.w3.org/2000/svg">
                        <path id="f_1_" style="" d="M89.584,155.139V84.378h23.742l3.562-27.585H89.584V39.184   c0-7.984,2.208-13.425,13.67-13.425l14.595-0.006V1.08C115.325,0.752,106.661,0,96.577,0C75.52,0,61.104,12.853,61.104,36.452   v20.341H37.29v27.585h23.814v70.761H89.584z"  data-original="#010002" />
                     </g>
                  </g>
               </svg>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="32" height="32" x="0" y="0" viewBox="0 0 511 511.9" style="enable-background:new 0 0 512 512" xml:space="preserve" class="fill-white hover:bg-black bg-grayLight p-2 rounded-full">
                  <g>
                     <path xmlns="http://www.w3.org/2000/svg" d="m510.949219 150.5c-1.199219-27.199219-5.597657-45.898438-11.898438-62.101562-6.5-17.199219-16.5-32.597657-29.601562-45.398438-12.800781-13-28.300781-23.101562-45.300781-29.5-16.296876-6.300781-34.898438-10.699219-62.097657-11.898438-27.402343-1.300781-36.101562-1.601562-105.601562-1.601562s-78.199219.300781-105.5 1.5c-27.199219 1.199219-45.898438 5.601562-62.097657 11.898438-17.203124 6.5-32.601562 16.5-45.402343 29.601562-13 12.800781-23.097657 28.300781-29.5 45.300781-6.300781 16.300781-10.699219 34.898438-11.898438 62.097657-1.300781 27.402343-1.601562 36.101562-1.601562 105.601562s.300781 78.199219 1.5 105.5c1.199219 27.199219 5.601562 45.898438 11.902343 62.101562 6.5 17.199219 16.597657 32.597657 29.597657 45.398438 12.800781 13 28.300781 23.101562 45.300781 29.5 16.300781 6.300781 34.898438 10.699219 62.101562 11.898438 27.296876 1.203124 36 1.5 105.5 1.5s78.199219-.296876 105.5-1.5c27.199219-1.199219 45.898438-5.597657 62.097657-11.898438 34.402343-13.300781 61.601562-40.5 74.902343-74.898438 6.296876-16.300781 10.699219-34.902343 11.898438-62.101562 1.199219-27.300781 1.5-36 1.5-105.5s-.101562-78.199219-1.300781-105.5zm-46.097657 209c-1.101562 25-5.300781 38.5-8.800781 47.5-8.601562 22.300781-26.300781 40-48.601562 48.601562-9 3.5-22.597657 7.699219-47.5 8.796876-27 1.203124-35.097657 1.5-103.398438 1.5s-76.5-.296876-103.402343-1.5c-25-1.097657-38.5-5.296876-47.5-8.796876-11.097657-4.101562-21.199219-10.601562-29.398438-19.101562-8.5-8.300781-15-18.300781-19.101562-29.398438-3.5-9-7.699219-22.601562-8.796876-47.5-1.203124-27-1.5-35.101562-1.5-103.402343s.296876-76.5 1.5-103.398438c1.097657-25 5.296876-38.5 8.796876-47.5 4.101562-11.101562 10.601562-21.199219 19.203124-29.402343 8.296876-8.5 18.296876-15 29.398438-19.097657 9-3.5 22.601562-7.699219 47.5-8.800781 27-1.199219 35.101562-1.5 103.398438-1.5 68.402343 0 76.5.300781 103.402343 1.5 25 1.101562 38.5 5.300781 47.5 8.800781 11.097657 4.097657 21.199219 10.597657 29.398438 19.097657 8.5 8.300781 15 18.300781 19.101562 29.402343 3.5 9 7.699219 22.597657 8.800781 47.5 1.199219 27 1.5 35.097657 1.5 103.398438s-.300781 76.300781-1.5 103.300781zm0 0" data-original="#000000" class=""/>
                    <path xmlns="http://www.w3.org/2000/svg" d="m256.449219 124.5c-72.597657 0-131.5 58.898438-131.5 131.5s58.902343 131.5 131.5 131.5c72.601562 0 131.5-58.898438 131.5-131.5s-58.898438-131.5-131.5-131.5zm0 216.800781c-47.097657 0-85.300781-38.199219-85.300781-85.300781s38.203124-85.300781 85.300781-85.300781c47.101562 0 85.300781 38.199219 85.300781 85.300781s-38.199219 85.300781-85.300781 85.300781zm0 0"  data-original="#000000" class="bg-grayLight"/>
                    <path xmlns="http://www.w3.org/2000/svg" d="m423.851562 119.300781c0 16.953125-13.746093 30.699219-30.703124 30.699219-16.953126 0-30.699219-13.746094-30.699219-30.699219 0-16.957031 13.746093-30.699219 30.699219-30.699219 16.957031 0 30.703124 13.742188 30.703124 30.699219zm0 0"  />
                  </g>
               </svg>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="32" height="32" x="0" y="0" viewBox="0 0 409.592 409.592" style="enable-background:new 0 0 512 512" xml:space="preserve" class="fill-white hover:bg-black bg-grayLight p-2 rounded-full">
                  <g>
                     <g xmlns="http://www.w3.org/2000/svg">
                        <g>
                           <path d="M403.882,107.206c-2.15-17.935-19.052-35.133-36.736-37.437c-107.837-13.399-216.883-13.399-324.685,0    C24.762,72.068,7.86,89.271,5.71,107.206c-7.613,65.731-7.613,129.464,0,195.18c2.15,17.935,19.052,35.149,36.751,37.437    c107.802,13.399,216.852,13.399,324.685,0c17.684-2.284,34.586-19.502,36.736-37.437    C411.496,236.676,411.496,172.937,403.882,107.206z M170.661,273.074V136.539l102.4,68.27L170.661,273.074z" data-original="#000000" class=""/>
                        </g>
                     </g>
                  </g>
               </svg>
            </div>
          </div>
          <NuxtLink v-if="!showSearchBarMobile" to="/" class="flex w-full justify-center">
            <nuxt-img
                preload
                width="840"
                height="68"
                alt="logo_a"
                class="w-[68%] sm:w-[420px] md:w-[550px] lg:w-[840px] hover:opacity-80 mt-2.5 sm:mt-1 z-10" :src="logo_big"/>
          </NuxtLink>
          <div class="absolute w-full h-full left-0 top-0 flex items-center drop-shadow-2xl	 md:hidden">
           <div class="relative w-full">
             <div v-if="showSearchBarMobile">
                 <div class="relative text-black focus-within:text-black text-center">
                   <input type="search" v-model="search" @keyup.enter="submitSearch()" name="q" class="placeholder-custom max-h-10 py-2 text-lg text-black border
                   focus:ring-violet-300 border-neutral-200 px-2 focus:ring-1 focus:shadow-inner focus:outline-none focus:text-black w-[70%]"
                          placeholder="Search" autocomplete="off"
                   >
                 </div>
             </div>
             <div @click="showSearchBarMobile = !showSearchBarMobile">
                <span class="absolute inset-y-0 right-0 flex items-center px-2">
                    <button id="search" name="search" type="submit" class="p-1 focus:outline-none focus:shadow-outline" aria-label="search">
                      <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" class="w-6 h-6">
                        <path d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                      </svg>
                    </button>
                </span>
             </div>
           </div>
          </div>
        </div>
        <div class="md:flex justify-center pb-4 w-full hidden">
          <div class="w-full">
            <nav class="desktop-menu"
                @mouseleave="highlightedMenuItem = -1"
            >
              <ul class="font-body-font f text-sm lg:text-base xl:text-2xl uppercase flex justify-center flex-wrap">
                <li v-for="(menuItem, menuIndex) in menuItems" :key="menuItem.title"  class="relative inline-flex z-50">
                  <template v-if="menuItem.children.length === 0">
                    <NuxtLink
                        @mouseover.stop="highlightedMenuItem = menuIndex"
                        @click.stop="highlightedMenuItem = menuIndex"
                        :to="menuItem.link"
                        :class="menuItem.class"
                        class="border-r border-black px-3 xl:px-[1.8rem] hover:underline text-black"
                    >
                      {{ menuItem.title }}
                    </NuxtLink>
                  </template>
                  <template v-else>
                    <div
                        @mouseover.stop="highlightedMenuItem = menuIndex"
                        @click.stop="highlightedMenuItem = menuIndex"
                        class="px-3 xl:px-3.5 hover:underline inline-flex items-center relative"
                        :class="(menuIndex+1 !== menuItems.length)? 'border-r border-black':''"
                    >
                        <span class="mr-1">
                          {{ menuItem.title }}
                        </span>
<!--                        <svg class="w-5 h-5 text-indigo-100 dark:text-white"-->
<!--                             xmlns="http://www.w3.org/2000/svg"-->
<!--                             viewBox="0 0 20 20"-->
<!--                             fill="#000">-->
<!--                          <path-->
<!--                              fill-rule="evenodd"-->
<!--                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"-->
<!--                              clip-rule="evenodd"-->
<!--                          />-->
<!--                        </svg>-->
                    </div>
                    <ul
                        :class="highlightedMenuItem === menuIndex ? 'show' : 'hide'"
                        class="absolute custom-dropdown top-[22px] mt-1 py-4 shadow-lg bg-white text-2xl w-[240px] z-10"
                    >
                      <li v-for="childrenMenuItem in menuItem.children" :key="childrenMenuItem.title">
                        <NuxtLink
                            :to="childrenMenuItem.link"
                            class="hover:underline p-1 px-3 block font-light text-grayDark"
                        >
                          {{ childrenMenuItem.title }}
                        </NuxtLink>
                      </li>
                    </ul>
                  </template>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script setup>
import {computed, onMounted, ref, watch} from 'vue'
import { useMainStore, useDomainStore} from '~/stores/main'
import {http} from "~/utils/http";
import {navigateTo} from "nuxt/app";

const router = useRouter();
const route = useRoute();
const domainStore = useDomainStore();
const logo_big = computed(() => domainStore.logo_big);
const logo_small = computed(() => domainStore.logo_small);
const brother_link = computed(() => domainStore.brother_link);
const menu_title = computed(() => domainStore.menu_title);
const facebook = computed(() => domainStore.facebook);
const instagram = computed(() => domainStore.instagram);
const youtube = computed(() => domainStore.youtube);
const twitter = computed(() => domainStore.twitter);
const mainStore = useMainStore()
const menuItems = new ref([]);
const search = ref(route.query.search);
const highlightedMenuItem = new ref(-1);
let showmenumobile = ref(false);
let showSearchBarMobile = ref(false);
const userName = computed(() => mainStore.userName)
const userRoles = computed(() => mainStore.userRoles)
const cartProducts = computed(() => mainStore.cartProducts)
const countCart = computed(() => {
  if( cartProducts.value.length > 0 ){
    let count = 0;
    cartProducts.value.forEach((item)=>{
      count += item.quantity
    })
    return count;
  }
  else return 0;
})

const closeMobileMenu = () => {
  showmenumobile.value = false;
  document.body.classList.remove('disable-scroll');
}

function bodyscroll() {
  if (showmenumobile.value === true) {
    document.body.classList.add('disable-scroll')
  } else if (showmenumobile.value === false) {
    document.body.classList.remove('disable-scroll');
  }
}

const getUser = async() =>{
  try{
    const idToken = useCookie("idToken");
    if(idToken.value){
      await http.get('/api/checkUser').then((response) =>{
        mainStore.setUser({
          name: response.data.name,
          email: response.data.email,
          permissions: response.data.permissions,
          roles: response.data.roles,
          avatar: 'https://avatars.dicebear.com/api/avataaars/example.svg?options[top][]=shortHair&options[accessoriesChance]=93'
        })
      })
    }
  }catch (e){
  }
}

const logout = async() =>{
  try{
    await http.post('api/logout')
        .then((response) =>{
          const idToken = useCookie("idToken");
          idToken.value = null;
          http.defaults.headers.common.Authorization = null;
          mainStore.setUser({
            name: null,
            email: null,
            permissions: [],
            roles: [],
            avatar: ''
          })
          window.location.reload()
        })
  }catch (e) {

  }

}

menuItems.value.push({
  title: 'Subscribe',
  link: "/subscribe",
  class: 'text-themeRed',
  children: [],
});

menuItems.value.push({
  title: 'Magazine',
  children: [
    {
      title: 'Subscribe',
      link: "/subscribe",
    },
    {
      title: 'Advertise',
      link: "/advertise",
    },
    {
      title: 'Digital Edition',
      link: "/issue",
    },
    {
      title: 'Featured Advertisers',
      link: "/advertiser-gallery",
    },
    {
      title: menu_title.value,
      link: brother_link.value+"issue",
    },
  ]
});

menuItems.value.push({
  title: 'News',
  link: "/news",
  children: [],
});

menuItems.value.push({
  title: 'Results',
  children: [
    {
      title: 'Horse Shows',
      link: "/horse-shows",
    },
    {
      title: 'All-American Standings',
      link: "/all-american-standings",
    },
    {
      title: 'Sire Standings',
      link: "/sire-standings",
    },
  ]
});

menuItems.value.push({
  title: 'Calendar',
  link: "/event",
  children: [],
});

menuItems.value.push({
  title: 'Photos',
  link: "/photo-gallery",
  children: [],
});

menuItems.value.push({
  title: 'Videos',
  link: "/videos",
  children: [],
});

menuItems.value.push({
  title: 'Directory',
  link: "",
  children: [
    {
      title: 'Farms and Stables',
      link: "/directory-farms-stables",
    },
    {
      title: 'Products and Services',
      link: "/directory-products-services",
    },
  ],
});

menuItems.value.push({
  title: 'Horse Listings',
  link: "",
  children: [ {
    title: 'For Sale',
    link: "/for-sale-gallery",
  },
    {
      title: 'Stallions',
      link: "/stallions-gallery",
    },
  ],
});

menuItems.value.push({
  title: 'Shop',
  link: "",
  children: [
    {
      title: 'Stylish Equestrian',
      link: "https://stylishequestrian.com/",
    },
    {
      title: 'Issues & Books',
      link: "/shop",
    },
  ],
});

menuItems.value.push({
  title: 'About',
  link: "",
  children: [
    {
      title: 'Our Team',
      link: "/our-team",
    },
    {
      title: 'Careers',
      link: "/employment",
    },
    {
      title: 'Our History',
      link: "/our-history",
    },
    {
      title: 'Contact Us',
      link: "/contact",
    },
  ],
});

const submitSearch = () => {
  router.push('/search-results?search='+search.value).then(() => { router.go() });
}

onMounted(async () => {
  mainStore.setProducts()
  const idToken = useCookie("idToken");

  http.defaults.headers.common.Authorization = "Bearer "+idToken.value;
  await getUser();
})
</script>
